// TODO: Improve the keys generation
export const InvestmentAlertsKeys = {
  base: ['investmentAlerts'],
  byPagination: () => [...InvestmentAlertsKeys.base].filter(Boolean) ?? []
};
